export default function Navigation(snapper) {
    const sectionContent = document.getElementById('content');
    const togglers = document.querySelectorAll('.toggler');
    togglers.forEach(toggler => {
        toggler.addEventListener('click', e => {
            e.preventDefault();

            snapper.state().state === 'left' ?
                snapper.close('left') :
                snapper.open('left');

            fixedNav(sectionContent);
        });
    });

    fixedNav(sectionContent);

    sectionContent.addEventListener('scroll', () => {
        fixedNav(sectionContent);
    });

    window.addEventListener('resize', () => {
        fixedNav(sectionContent);
    });


}

function fixedNav(sectionContent) {
    const nav = document.getElementById('nav');
    if($("#content-carousel").length > 0){
        if ($(sectionContent).scrollTop() >= $("#content-carousel").height()) {
            $(nav).addClass('fixed-nav');
        } else {
            $(nav).removeClass('fixed-nav');
        }
    } else {
        $(nav).addClass('fixed-nav');

    }

    // fix the discover button on mobile device
    if ($(sectionContent).is('.halfed') && $(window).width() < 740) {
        $('button.toggler').css('top', $(sectionContent).scrollTop());
    } else {
        $('button.toggler').css('top', 0);
    }
}
